import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { RemittanceTransaction } from '../../../../../models/transactions/remittance-transaction';

@Component({
  selector: 'app-remittance-transaction-preview-card',
  templateUrl: './remittance-transaction-preview-card.component.html',
  styleUrls: ['./remittance-transaction-preview-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RemittanceTransactionPreviewCardComponent {
  @Input() transaction!: RemittanceTransaction;
  @Output() viewTransactionClick: EventEmitter<RemittanceTransaction> = new EventEmitter();
}
